
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Jai Jai Deen Dayalaya Satyanarayan Deva" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Jai Jai Deen Dayalaya Satyanarayan Deva" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Jai Jai Deen Dayalaya Satyanarayan Deva, Satyanarayan Aarti, Satyanarayan Vrat Katha Aarti, Lord Vishnu Aarti, सत्यनारायण आरती'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Jai Jai Deen Dayalaya Satyanarayan Deva, Satyanarayan Aarti, Lord Satyanarayan Aarti lyrics, Satyanarayan worship, Satyanarayan Bhajan, Devotional aarti, Satyanarayan Vrat Katha Aarti, Lord Vishnu Aarti, Satyanarayan Swami Ki Aarti, Aarti of Satyanarayan, satyanarayan aarti marathi, सत्यनारायण आरती lyrics, सत्यनारायणाची आरती, jai jai din dayala satyanarayan deva in english, jai jai din dayala satyanarayan deva in marathi'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/satyanarayan.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/satyanarayan.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Jai Jai Deen Dayalaya Satyanarayan Deva | Satyanarayan Aarti - जय जय दीनदयाळा सत्यनारायण देवा(सत्यनारायण आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/satyanarayan"
        },
        "headline": "Jai Jai Deen Dayalaya Satyanarayan Deva - जय जय दीनदयाळा सत्यनारायण देवा(सत्यनारायण आरती)",
        "name" : "Jai Jai Deen Dayalaya Satyanarayan Deva - Satyanarayan Aarti",
        "description": "Explore the full lyrics of Aarti 'Jai Jai Deen Dayalaya Satyanarayan Deva' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/satyanarayan.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  